import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/asset-inventory')({
  beforeLoad: () => getTitleContextSlice('Asset Inventory'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
